import { combineReducers } from '@reduxjs/toolkit';

import { chatGroupReducer } from './slice/chatGroupSlice';
import { errorReducer } from './slice/errorSlice';
import { friendReducer } from './slice/friendSlice';
import { userReducer } from './slice/userSlice';
import { voiceCallReducer } from './slice/voiceCallSlice';
import { websocketReducer } from './slice/websocketSlice';

export const rootReducer = combineReducers({
    user: userReducer,
    chatGroup: chatGroupReducer,
    friend: friendReducer,
    voiceCall: voiceCallReducer,
    error: errorReducer,
    websocket: websocketReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
